import React, {useEffect} from "react";
import {SDrawerOrModal, SGeneralForms} from "shj-components";
import styles from "@/pages/salesWorkbench/workbenchList/components/SeatAddClueModal/index.module.less";
import {phoneRegExp} from "@/utils/regular.tsx";
import {Form, message, Select} from "antd";
import {useSetState} from "ahooks";
import {getCustomerSource} from "@/services/customerServices.ts";
import {getBusinessLines, getChannelBrandAgent} from "@/services/getUsers.ts";
import {getEnums, httpOrgList} from "@/services/homeService.ts";
import {getAnchorFn, getUserIdentityFn} from "@/pages/clueManage/utils.tsx";
import {getDispatchMnrList} from "@/services/saleOpServices.ts";
import {addClue} from "@/services/callCenter";
import {getUser} from "shj-utils";

export const ChannelAddClueModal = (props) => {
  const {open, onClose, reload} = props;
  const userInfo = getUser()

  const [form] = Form.useForm()
  const [state, setState] = useSetState<any>({
    loading: false
  })

  useEffect(() => {
   if(open) {
     getOptions()
     onCancel()
   }
  }, [open]);

  const getOptions = () => {
    setState({loading: true})
    Promise.allSettled([
      getBusinessLines(),
      getEnums("dispatcher", "com.shj.saas.plus.clue.enums.ArmyAffiliation"),
      httpOrgList(),
      getUserIdentityFn(['ykf']),
      getEnums('plus-crm', 'com.shj.saas.plus.crm.enums.HouseNatureEnum'),
      getChannelBrandAgent(),
    ]).then((resList: any) => {
      const map = {
        brandCodeList: resList?.[0]?.value instanceof Array ? resList?.[0]?.value : [],
        armyAffiliationList: resList?.[1]?.value instanceof Array ? resList?.[1]?.value : [],
        companyList: resList?.[2]?.value instanceof Array ? resList?.[2]?.value : [],
        ykfList: resList?.[3]?.value instanceof Array ? resList?.[3]?.value : [],
        bizOpPropertyTypeList: resList?.[4]?.value instanceof Array ? resList?.[4]?.value : [],
        channelBrandList: resList?.[5]?.value instanceof Array ? resList?.[5]?.value : [],
      }
      setState(map)
    }).finally(() => {
      setState({loading: false})
    })
  }

  const handleCity = (data) => {
    const obj = {}
    return data.reduce((res, item) => {
      if(!obj[item.cityCode]) {
        res.push(item)
      }
      obj[item.cityCode] = true
      return res;
    }, [])
  }

  const onCompanyCodeChange = (val: string) => {
    form.setFieldsValue({channelId: null});
    setState({cityArea: [], anchor: [], liveOperation: [], advert: [], customerSource: []});
    // 报名城市
    getDispatchMnrList({storeId: val})
        .then((res: any) => {
          setState({cityArea: handleCity(res || [])});
        })
        .catch(() => {
          setState({cityArea: []});
        });
    if (val) {
      setState({loading: true})
      try {
        getAnchorFn('ANCHOR', val).then((res) => {
          setState({anchor: res || []})
        })
        getAnchorFn('LIVE_OPERATION', val).then((res) => {
          setState({liveOperation: res || []})
        })
        getAnchorFn('ADVERT', val).then((res) => {
          setState({advert: res || []})
        })
        getCustomerSource({state: 'CHECKED', orgId: val}).then(res => {
          setState({sourceChannelList: res || []})
        })
      } finally {
        setState({loading: false})
      }
    }
  };

  const onSubmit = () => {
    form.validateFields().then((values) => {
      const data: any = { ...values};
      if (data.channelId) {
        //修改客户来源正确值
        data.channelId = data.channelId[data.channelId.length - 1];
      }
      setState({loading: true})
      addClue({...data, clueSource: 'CHANNEL_CLUE_ADD'})
          .then((res: any) => {
            message.success(res.message || '操作成功');
            onClose?.()
            reload?.()
            onCancel();
          })
          .finally(() => {
            setState({loading: false})
          });
    })
  }

  const onCancel = () => {
    form.resetFields();
    form.setFieldValue('orgId', userInfo.companyId);
    onCompanyCodeChange(userInfo.companyId)
  }

  return <SDrawerOrModal
      title={'渠道人员新增'}
      open={open}
      onCancel={() => {
        onClose()
        reload()
      }}
      onOk={onSubmit}
      loading={state.loading}
  >
    <div className={styles.formWrap}>
      <SGeneralForms
          layout={'vertical'}
          formConfig={{form}}
          configs={[{
            formItem: [
              {
                spanCol: 12, label: '分公司', name: 'orgId',
                type: 'select',
                required: true,
                rules: [{required: true, message: '不能为空'}],
                comConfig: {
                  options: state.companyList,
                  fieldNames: {label: 'name', value: 'id'},
                  onChange: onCompanyCodeChange
                }
              },
              {
                spanCol: 12, label: '客户来源', name: 'channelId', type: 'cascader',
                required: true,
                rules: [{required: true, message: '不能为空'}],
                comConfig: {
                  expandTrigger: 'hover',
                  options: state.sourceChannelList,
                  showSearch: true,
                  notFoundContent: '请选择公司或无匹配数据',
                }
              },
              {
                spanCol: 12, label: '城市', name: 'cityAreaCode',
                type: 'select',
                required: true,
                rules: [{required: true, message: '不能为空'}],
                comConfig: {
                  options: state.cityArea,
                  fieldNames: {label: 'regionName', value: 'cityCode'}
                }
              },
              {
                spanCol: 12, label: '客户姓名', name: 'name',
                required: true,
                rules: [{required: true, message: '不能为空'}],
                comConfig: {
                  maxLength: 50,
                  showCount: true,
                  placeholder: '请输入客户名称',
                  onBlur: e => {
                    const value = e.target.value
                    // 去除所有空格
                    if (value) {
                      const newValue = value.replace(/\s/g, '')
                      form.setFieldValue('name', newValue)
                    }
                  },
                },
              },
              {
                spanCol: 12, label: '客户号码', name: 'phone',
                required: true,
                rules: [{required: true, message: '不能为空'}, {message: '请输入正确的电话号码', pattern: phoneRegExp}],
              },
              {
                spanCol: 12,
                label: '品牌',
                name: 'channelBrandId',
                required: true,
                rules: [{required: true, message: '不能为空'}],
                type: 'select',
                comConfig: {
                  options: state.channelBrandList,
                  fieldNames: {label: 'brandName', value: 'id'},
                  showSearch: true,
                  optionFilterProp: 'brandName',
                }
              },
              {
                spanCol: 12, label: '总分归属', name: 'armyAffiliation',
                type: 'select',
                required: true,
                rules: [{required: true, message: '不能为空'}],
                comConfig: {
                  options: state.armyAffiliationList,
                  fieldNames: {label: 'description', value: 'key'}
                }
              },
              {
                spanCol: 12, label: '主播', name: 'anchorEmployeeId',
                type: 'select',
                comConfig: {
                  options: state.anchor,
                  fieldNames: {label: 'userName', value: 'ucenterUserId'},
                  onChange: (e, op) => form.setFieldValue('anchorName', op?.userName),
                }
              },
              {spanCol: 12, label: '主播', name: 'anchorName', hidden: true},
              {
                spanCol: 12, label: '直播运营', name: 'liveOperationEmployeeId',
                type: 'select',
                comConfig: {
                  options: state.liveOperation,
                  fieldNames: {label: 'userName', value: 'ucenterUserId'},
                  onChange: (e, op) => form.setFieldValue('liveOperationName', op?.userName),
                }
              },
              {spanCol: 12, label: '直播运营', name: 'liveOperationName', hidden: true},
              {
                spanCol: 12, label: '优化师', name: 'advertEmployeeId',
                type: 'select',
                comConfig: {
                  options: state.advert,
                  fieldNames: {label: 'userName', value: 'ucenterUserId'},
                  onChange: (e, op) => form.setFieldValue('advertName', op?.userName),
                }
              },
              {spanCol: 12, label: '优化师', name: 'advertName', hidden: true},
              {
                spanCol: 24,
                label: '备注',
                name: 'remark',
                type: 'textarea',
                comConfig: {maxLength: 700, showCount: true}
              },
            ]
          }]}
      />
    </div>
  </SDrawerOrModal>;
}